import React from 'react';

import { Nullable } from '@clearverify/types';

import type { SearchContextValue } from './SearchContext';
import { SearchContext } from './SearchContext';

export const SearchProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [searchValue, setSearchValue] = React.useState<Nullable<string>>();
  const [searchCategory, setSearchCategory] = React.useState<Nullable<string>>();

  const contextValue = React.useMemo((): SearchContextValue => {
    return { searchValue, setSearchValue, searchCategory, setSearchCategory };
  }, [searchCategory, searchValue]);

  return <SearchContext.Provider value={contextValue}>{children}</SearchContext.Provider>;
};
